<template>
  <div>
    <ListWrapper
      ref="listWrapperReference"
      :url="url"
      :extraButtons="extraButtons"
      :addButtonText="$lang.newAccess"
      :emptyImage="generateEmptyImage"
      :emptyText="generateEmptyText"
      @getPermissions="handleUpdatePermissions"
      @handleAddButton="handleOpenAddPin"
    >
      <template slot-scope="{ items }">
        <CardList
          :items="items"
          loadingComponent="CenterExecuteAccess"
          :hasBody="false"
        >
          <template slot="header" slot-scope="{ item }">
            <CenterExecuteAccessHeaderItem
              :item="item"
              :permissions="permissions"
              @handleReloadList="handleReloadList"
            />
          </template>
        </CardList>
      </template>
    </ListWrapper>
    <AddCenterExecuteAccessPin
      :visible="isAddPin"
      :permissions="permissions"
      @handleClose="handleCloseAddPin"
      @handleReloadList="handleReloadList"
    />
    <Modal
      :show="isAddByExcelModal"
      :title="$lang.uploadAccessGroup"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
    >
      <template #body>
        <ResourceUploader
          :url="addByExcelUrl"
          :label="$lang.attachFile"
          :hasEditTitle="true"
          :cancelButton="true"
          exampleFileName="import_center_execute_access"
          uploaderName="center_execute_access_import"
          @onSuccessUpload="handleCloseAddByExcelModal"
          @close="handleCloseAddByExcelModal"
        />
      </template>
    </Modal>
  </div>
</template>

<script setup>
import {
  ListWrapper,
  CardList,
  Modal,
  ResourceUploader,
} from "@/components/re-design";
import CenterExecuteAccessHeaderItem from "./components/CenterExecuteAccessHeaderItem.vue";
import AddCenterExecuteAccessPin from "./components/AddCenterExecuteAccessPin.vue";
import { generateApiUrl, generateConfig, generateLang } from "@/shared/utils";
import { computed, provide, ref } from "vue";
import { includes } from "ramda";

const url = computed(() => generateApiUrl(["kanoon", "centerExecuteAccess"]));
const extraButtons = computed(() => [
  {
    caption: generateLang(["uploadAccessGroup"]),
    icon: "tray-arrow-up",
    show: true,
    permissions: ["admin", "edit"],
    loading: false,
    click: handleOpenAddByExcelModal,
  },
]);
const generateEmptyImage = computed(() =>
  generateConfig(["images", "shared", "redesign", "empty", "list"])
);
const generateEmptyText = computed(() => generateLang(["list_empty_text"]));

// handle reload list
const listWrapperReference = ref(null);
const handleReloadList = () => listWrapperReference.value.reload();

// handle permissions
const permissions = ref([]);
const handleUpdatePermissions = (data) => (permissions.value = data);

// handle add action
const isAddPin = ref(false);
const handleOpenAddPin = () => (isAddPin.value = true);
const handleCloseAddPin = () => (isAddPin.value = false);

// handle add by excel action
const addByExcelUrl = computed(() =>
  generateApiUrl(["kanoon", "importCenterExecuteAccess"])
);

const isAddByExcelModal = ref(false);
const handleOpenAddByExcelModal = () => (isAddByExcelModal.value = true);
const handleCloseAddByExcelModal = () => (isAddByExcelModal.value = false);

const checkSharedAccesses = (key) => {
  const SHARED_ACCESSES = [
    "ADD-PERSON-CENTER-EXECUTE-BY-EXCEL",
    "CASE-SHOW",
    "WASHUP",
    "SUBMIT-DELAY-TIME",
    "CHANGE-ASSESSMENT-PLAN",
    "EXCEL-EXPORT",
    "COPY",
    "REMOVE",
    "ADD",
    "STATUS-TYPE-1",
    "STATUS-TYPE-2",
    "STATUS-TYPE-3",
    "STATUS-TYPE-4",
    "STATUS-TYPE-5",
    "INCOMPLETE-COMPLETION",
    "GO_TO_DASHBOARD",
  ];
  let allowAccesses = [];

  allowAccesses = [
    "STATUS-TYPE-1",
    "STATUS-TYPE-2",
    "STATUS-TYPE-3",
    "STATUS-TYPE-4",
    "STATUS-TYPE-5",
  ];

  return includes(key, allowAccesses);
};

// generate provide data
provide("reloadList", handleReloadList);
provide("checkSharedAccesses", checkSharedAccesses);
</script>
